export default __webpack_public_path__ + "static/media/edit-btn.d52d3d40.svg";